import { formatDate } from './formatDate';
import { formatTime } from './formatTime';
export function formatInstant(value, mode) {
    switch (mode) {
        case 'date':
            return formatDate(value);
        case 'time':
            return formatTime(value);
        case 'datetime':
            return `${formatDate(value)} ${formatTime(value)}`;
        default: {
            const exhaustive = mode;
            return exhaustive;
        }
    }
}
